module.exports = __webpack_public_path__ + "img/logo_euronature.5143564d.jpg";